










































import { Dialog, Toast } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

@Component({})
export default class ManagementDetail extends Vue {
	list: { label: string; value: string; tip?: string }[] = [
		/* { label: "会员姓名: ", value: "张三" },
		{ label: "手机号码: ", value: "13442739127" },
		{ label: "会员卡号: ", value: "62739127985983454645" },
		{
			label: "会员等级: ",
			value: "普通会员",
			tip: "会员等级不满足参与条件!",
		},
		{ label: "积分余额: ", value: "10积分", tip: "积分余额不足!" },
		{
			label: "近1天消费总额: ",
			value: "100.00元",
			tip: "消费总额不满足参与条件!",
		}, */
	];

	joinBalance: boolean = true; //true: 积分登记, false: 不允许积分登记;
	joinFree: boolean = true; //true免费登记, false: 不允许免费登记;
	signUpBalance: number = 0;

	activityId: string = "";
	customerCid: string = "";
	isFree: number = 1;
	memberCardNo: string = "";
	memberMobile: string = "";
	limitType:boolean = false;  //每日累计上限和每日上限  true显示,false不显示
	limitMsg:string = '已达活动每日参与上限！'
	conditionFlag:number = 1 //消费门槛显示判断

	mounted() {
		const { memberCardNo, activityId }: any = this.$route.params;
		if (memberCardNo && activityId) {
			this.activityId = activityId;
			this.memberCardNo = memberCardNo;
			this.getInfo(memberCardNo, activityId)
		} else {
			if (!memberCardNo) {
				Toast.fail("没有查询到会员卡号!");
			}
			if (!activityId) {
				Toast.fail("没有查询到活动ID!");
			}
			this.$router.replace("/activitySign");
		}
	}

	async getInfo(memberCardNo: string, activityId: string) {
		Toast.loading({ duration: 0, forbidClick: true });
		const {
			error: activityError,
			success: activitySuccess,
		}: any = await this.$request("SIGNUP_ACTIVITY_INFO", { activityId });
		const { error, success }: any = await this.$request(
			"SIGNUP_ACTIVITY_MEMBER_INFO",
			{
				memberCardNo,
				activityId,
			}
		);
		Toast.clear();
		if (activityError) {
			Dialog.alert({
				title: "查询失败",
				message: "查询活动信息失败, 请重试!",
			}).then(() => {
				this.$router.replace("/activitySign");
			});
			return;
		}
		if (error) {
			Dialog.alert({
				title: "查询失败",
				message: "查询会员信息失败, 请重试!",
			}).then(() => {
				this.$router.replace("/activitySign");
			});
			return;
		}
		if (activitySuccess && success) {
			const activity: any = activitySuccess.data;
			const data: any = success.data;
			const { 
				error:gradeError,
				success:gradeSuccess 
			}: any = await this.$request(
				"SIGNUP_ACTIVITY_GRADE_RULE",
				{
					activityId:this.activityId,
					memberCardGrade:data.memberCardGrade,
				}
			);
			if(gradeSuccess){
				const gradeData: any = gradeSuccess.data;
				this.conditionFlag = 1
				// 如果会员的累计限制 大于或者等于 卡规则累计限制
				let memberLimitAll = data.perCumulativeLimit,
						ruleLimitAll = gradeData.perCumulativeLimit,
						memberLimitDay = data.perDayLimit,
						ruleLimitDay = gradeData.perDayLimit
						
				if(ruleLimitAll !==0 && memberLimitAll >= ruleLimitAll ){
					this.limitType = true
					this.limitMsg = "已达活动累计参与上限！"
				}else if(ruleLimitDay !==0 && memberLimitDay >= ruleLimitDay){
					this.limitType = true
					this.limitMsg = "已达活动每日参与上限！"
				}else{
					this.limitType = false
				}
			}else{
				if(gradeError.code == 600003){
					this.conditionFlag = 2
				}
			}
			this.customerCid = data.customerCid;
			this.memberMobile = data.memberMobile;
			this.list.push({
				label: "会员姓名: ",
				value: `${data.memberName}`,
				tip: "",
			});
			this.list.push({
				label: "手机号码: ",
				value: `${data.memberMobile}`,
				tip: "",
			});
			this.list.push({
				label: "会员卡号: ",
				value: `${data.memberCardNo}`,
				tip: "",
			});

			const balance: number =
				(data.customerScoreAccountVO || {}).balance || 0;
			const cardGrade: any =
				activity.isAllMember == 1
					? {
							memberCardGrade: data.memberCardGrade,
							memberCardName: data.memberCardName,
							memberPoint: activity.memberPoint,
					  }
					: (activity.gradeRuleList || []).find(
							(item: any) =>
								item.memberCardGrade == data.memberCardGrade
					  );

			let gradeInvalid: boolean = true;
			if (!cardGrade) {
				gradeInvalid = false;
				this.list.push({
					label: "会员等级: ",
					value: `${data.memberCardName}`,
					tip: "会员等级不满足参与条件!",
				});
			} else {
				this.list.push({
					label: "会员等级: ",
					value: `${cardGrade.memberCardName}`,
					tip: "",
				});
			}

			let scoreInvalid: boolean = true;
			if (gradeInvalid) {
				if (balance < cardGrade.memberPoint) {
					scoreInvalid = false;
					this.list.push({
						label: "积分余额: ",
						value: `${(this as any).$thousand(balance)}积分`,
						tip: "积分余额不足!",
					});
				}
			}
			if (scoreInvalid) {
				this.list.push({
					label: "积分余额: ",
					value: `${(this as any).$thousand(balance)}积分`,
					tip: "",
				});
			}
			if(this.conditionFlag == 1){  //判断卡登记是否存在
				if(gradeSuccess.data.conditionType == 1){
					this.list.push({
						label: `近${gradeSuccess.data.conditionDay}天消费总额: `,
						value: `${(this as any).$currency(
							(data.totalFee || 0) / 100
						)}`,
						tip: data.totalFee < gradeSuccess.data.conditionPrice ? "消费总额不满足参与条件!" : "",
					});
				}else{
					this.list.push({
						label: `消费门槛: `,
						value: `无门槛`,
						tip: "",
					});
				}
			}else{
				this.list.push({
					label: `消费门槛: `,
					value: `无门槛`,
					tip: "",
				});
			}

			this.joinBalance = false;
			if (balance > 0) {
				if (cardGrade && cardGrade.memberPoint > 0) {
					this.signUpBalance = cardGrade.memberPoint;
					this.joinBalance = true;
				}
			}

			if (activity.activityStatus != 1) {
				Toast(
					`当前活动处于 ${activity.activityStatusDesc} 状态, 无法报名!`
				);
				this.joinBalance = false;
				this.joinFree = false;
			}
		}
	}

	onConfirm(
		params: { title: string; message: string; [propName: string]: any },
		cb: Function,
		err?: Function
	) {
		return Dialog.confirm(params)
			.then(() => {
				cb && cb();
			})
			.catch(() => {
				err && err();
			});
	}

	onJoin(isFree: number = 1) {
		return this.$request("SIGNUP_ACTIVITY_MEMBER_JOIN", {
			memberCardNo: this.memberCardNo,
			activityId: this.activityId,
			customerCid: this.customerCid,
			memberMobile: this.memberMobile,
			isFree,
		});
	}

	onSignUp() {
		this.onConfirm(
			{
				title: "确认登记",
				message: `确认扣减会员${this.signUpBalance}余额积分参与该活动？`,
			},
			async () => {
				var { error, success }: any = await this.onJoin(2);
				if (success) {
					this.$toast({
						type: "success",
						message: "登记完成!",
					});
					setTimeout(() => {
						this.$router.replace("/activitySign");
					}, 1500);
				}
				if (error && error.code == -1) {
					this.onConfirm(
						{
							title: "积分扣减失败",
							message: `是否允许会员免费参与活动？`,
							confirmButtonText: "允许",
							showCancelButton: true,
							cancelButtonText: "不允许",
						},
						async () => {
							var { error, success }: any = await this.onJoin(1);
							if (error) {
								this.$toast({
									type: "fail",
									message: error.msg || error.message,
								});
							}
							if (success) {
								this.$toast({
									type: "success",
									message: "登记完成!",
								});
								setTimeout(() => {
									this.$router.replace("/activitySign");
								}, 1500);
							}
						},
						() => {
							//this.$router.replace("/activitySign");
						}
					);
				}
			}
		);
	}

	onSignUpFree() {
		this.onConfirm(
			{
				title: "确认登记",
				message: `确认会员免费参与该活动？`,
			},
			async () => {
				var { error, success }: any = await this.onJoin(1);
				if (error) {
					this.$toast({
						type: "fail",
						message: error.msg || error.message,
					});
				}
				if (success) {
					this.$toast({
						type: "success",
						message: "登记完成!",
					});
					setTimeout(() => {
						this.$router.replace("/activitySign");
					}, 1500);
				}
			}
		);
	}
	goBack(){
		this.$router.replace("/activitySign");
	}
}
